import React from 'react';
import { motion } from 'framer-motion';
export const MainCTA = () => {
  return <section id="cta" className="relative py-40 overflow-hidden aurora-bg" data-id="element-130">
      {/* Dark overlay to ensure text readability */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-[2px]" data-id="element-131" />

      <div className="container mx-auto px-6 relative z-10 text-center flex flex-col items-center" data-id="element-132">
        <motion.h2 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-8 leading-tight max-w-4xl" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-133">
          Cada día sin página web es un día regalándole clientes a tu
          competencia.
        </motion.h2>

        <motion.p className="text-xl md:text-2xl text-gray-200 mb-16 font-serif italic" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} data-id="element-134">
          La pregunta es simple:
          <br className="md:hidden" data-id="element-135" /> ¿Te van a encontrar a vos... o a alguien
          más?
        </motion.p>

        <motion.button className="relative group overflow-hidden bg-primary text-background font-bold text-base md:text-xl tracking-widest py-5 px-10 rounded-full shadow-[0_0_30px_rgba(212,175,55,0.5)] hover:shadow-[0_0_50px_rgba(212,175,55,0.8)] transition-all duration-300 shimmer animate-pulse-slow" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6,
        duration: 0.5
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={() => window.open('https://wa.me/5492236514357?utm_source=chatgpt.com', '_blank', 'noopener,noreferrer')} data-id="element-136">
          ✦ QUIERO MI PÁGINA WEB AHORA ✦
        </motion.button>

        <motion.p className="mt-8 text-sm md:text-base text-gray-300 font-medium tracking-wide" initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 1.2,
        duration: 0.8
      }} data-id="element-137">
          ⚡ Lugares limitados por semana · Entrega en 48 horas · 100%
          personalizada
        </motion.p>
      </div>
    </section>;
};